var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 7,
    viewBox: "0 0 179 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 0,
    height: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.674072 3.5L5.67407 6.38675V0.613249L0.674072 3.5ZM178.674 3.5L173.674 0.613249V6.38675L178.674 3.5ZM5.17407 4H174.174V3H5.17407V4Z",
    fill: "#51565E",
    mask: "url(#)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageArrow);
export default __webpack_public_path__ + "static/media/package-arrow.bcb90f6eb522c9c33921bc4cb63dde2b.svg";
export { ForwardRef as ReactComponent };